<template>
  <div>
    <v-speed-dial
      v-model="fab"
      :top="top"
      :bottom="bottom"
      :right="right"
      :left="left"
      :direction="direction"
      :open-on-hover="hover"
      :transition="transition"
      :absolute="true"
    >
      <template v-slot:activator>
        <v-btn v-model="fab" color="transparent" dark fab>
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-account-circle</v-icon>
        </v-btn>
      </template>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn fab dark small color="indigo" v-on="on" @click="logUserOut">
            <v-icon>mdi-lock</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('loggedIn.logout') }}</span>
      </v-tooltip>

      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            dark
            small
            color="green"
            v-on="on"
            @click="profileDialog = true"
          >
            <v-icon>mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('loggedIn.profile') }}</span>
      </v-tooltip>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            dark
            small
            color="blue"
            v-on="on"
            @click="settingsDialog = true"
          >
            <v-icon>mdi-cog-outline</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('loggedIn.settings') }}</span>
      </v-tooltip>
    </v-speed-dial>
    <v-dialog id="settingsDialog" v-model="settingsDialog" max-width="500" dark>
      <settings-dialog :settings="settings" @closeDialog="closeDialog" />
    </v-dialog>
    <v-dialog id="profileDialog" v-model="profileDialog" max-width="500" dark>
      <profile-dialog :user="user" @closeDialog="closeDialog" />
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import settingsDialog from '../Dialogs/SettingsDialog'
import profileDialog from '../Dialogs/ProfileDialog'

export default {
  name: 'UserNavigation',
  components: {
    settingsDialog,
    profileDialog
  },
  data: () => ({
    direction: 'top',
    fab: false,
    fling: false,
    hover: false,
    tabs: null,
    top: false,
    right: true,
    bottom: true,
    left: false,
    transition: 'slide-y-reverse-transition',
    settingsDialog: false,
    profileDialog: false
  }),
  computed: {
    activeFab() {
      switch (this.tabs) {
        case 'one':
          return { class: 'purple', icon: 'account_circle' }
        case 'two':
          return { class: 'red', icon: 'edit' }
        case 'three':
          return { class: 'green', icon: 'keyboard_arrow_up' }
        default:
          return {}
      }
    },
    ...mapState('settings', ['settings']),
    ...mapState('authentication', ['user'])
  },
  watch: {
    top(val) {
      this.bottom = !val
    },
    right(val) {
      this.left = !val
    },
    bottom(val) {
      this.top = !val
    },
    left(val) {
      this.right = !val
    }
  },
  methods: {
    logUserOut() {
      this.$emit('log-user-out')
    },
    closeDialog() {
      this.settingsDialog = false
      this.profileDialog = false
    }
  }
}
</script>
